import * as React from "react";

import Badge from "./Badge";
import {useEffect, useState} from "react";
import round0Image from "../../../../assets/images/dailystudy_round0.png";
import round1Image from "../../../../assets/images/dailystudy_round1.png";
import round2Image from "../../../../assets/images/dailystudy_round2.png";
import round3Image from "../../../../assets/images/dailystudy_round3.png";

const StudentRowDaily = ({ index, name, number, stageResultList, resultTags}) => {
    const [roundCnt, setRoundCnt] = useState(0);

    const roundImageList = [round0Image, round1Image, round2Image, round3Image];

    // 정확도에 따른 색상 결정 함수
    const getAccuracyColor = (accuracy) => {
        if (accuracy === 100) {
            return "#7494FF";
        } else if (accuracy >= 80) {
            return "#00B079";
        } else {
            return "#EF7070";
        }
    };

    useEffect(() => {
        if(stageResultList){
            setRoundCnt(stageResultList.length);
        }

    }, [stageResultList]);

    return (
        <tbody>
        <tr
            className="flex flex-wrap items-center text-base font-semibold rounded-xl min-h-[100px] max-md:max-w-full">
            <td
                className="flex flex-col justify-center  self-stretch px-2 align-middle text-center whitespace-nowrap text-slate-400 w-[80px] border-l-[1px] border-r-[1px] border-b-[1px] border-gray-200">
                {number}
            </td>
            <td
                className="line-clamp-4 justify-center px-2 whitespace-pre-wrap text-zinc-500 w-[110px] border-r-[1px] border-b-[1px] border-gray-200 h-[108px] flex items-center">
                {name}
            </td>
            <td
                className="flex flex-col justify-center items-center self-stretch px-2 min-h-[104px] text-zinc-500 w-[360px] border-r-[1px] border-b-[1px] border-gray-200">
                <div
                    className="flex-col w-[295px] h-[62px] text-center items-center justify-center text-[12px] font-[600] ">
                    <div
                        className="flex justify-center items-center"
                    >
                        <img
                            src={roundImageList[Math.min(roundCnt, roundImageList.length - 1)]}
                            alt="round info"
                            className="flex "
                        />
                    </div>
                    <div className="flex justify-between mt-3">
                        {stageResultList[0] ? (
                            <div className="flex flex-col justify-center items-center w-[55px] h-[30px]">
                                <div className="flex justify-center items-center h-[8px]" style={{ color: getAccuracyColor(stageResultList[0].accuracy) }}>
                                    {stageResultList[0].accuracy + "%"}
                                </div>
                                <div>
                                    {stageResultList[0].time > 60 ? `${Math.floor(stageResultList[0].time / 60)}분 ${stageResultList[0].time % 60}초` : stageResultList[0].time + "초"}
                                </div>
                            </div>
                        ) : (
                            <div className="flex flex-col justify-center items-center w-[55px] h-[30px]">
                                <div className="flex justify-center items-center h-[8px]">-</div>
                                <div>-</div>
                            </div>
                        )}
                        {stageResultList[1] ? (
                            <div className="flex flex-col justify-center items-center w-[55px] h-[30px]">
                                <div className="flex justify-center items-center h-[8px]" style={{ color: getAccuracyColor(stageResultList[1].accuracy) }}>
                                    {stageResultList[1].accuracy + "%"}
                                </div>
                                <div>
                                    {stageResultList[1].time > 60 ? `${Math.floor(stageResultList[1].time / 60)}분 ${stageResultList[1].time % 60}초` : stageResultList[1].time + "초"}
                                </div>
                            </div>
                        ) : (
                            <div className="flex flex-col justify-center items-center w-[55px] h-[30px]">
                                <div className="flex justify-center items-center h-[8px]">-</div>
                                <div>-</div>
                            </div>
                        )}
                        {stageResultList[2] ? (
                            <div className="flex flex-col justify-center items-center w-[55px] h-[30px]">
                                <div className="flex justify-center items-center h-[8px]" style={{ color: getAccuracyColor(stageResultList[2].accuracy) }}>
                                    {stageResultList[2].accuracy + "%"}
                                </div>
                                <div>
                                    {stageResultList[2].time > 60 ? `${Math.floor(stageResultList[2].time / 60)}분 ${stageResultList[2].time % 60}초` : stageResultList[2].time + "초"}
                                </div>
                            </div>
                        ) : (
                            <div className="flex flex-col justify-center items-center w-[55px] h-[30px]">
                                <div className="flex justify-center items-center h-[8px]">-</div>
                                <div>-</div>
                            </div>
                        )}
                    </div>
                </div>
            </td>
            <td
                className="flex flex-col justify-center self-stretch px-[14px] min-h-[108px] text-zinc-500  border-r-[1px] border-b-[1px] border-gray-200 items-center text-xs font-medium text-center w-[440px]">
                <div className="flex flex-col justify-center items-center self-stretch my-auto min-w-[240px]">
                    <div
                        className={`flex gap-2.5 items-center flex-wrap ${resultTags.length > 3 ? `w-[330px]` : <></>}`}>
                        {resultTags.map((tag, index) => (
                            <Badge key={index} text={tag}/>
                        ))}
                    </div>
                </div>
            </td>
        </tr>
        </tbody>
    );
}

export default StudentRowDaily;